// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comments-cls1___72366c8481fe9aa1e5c{/*!*/}.Comments-cls2___1f96f71214943147928{padding:2px;width:4px;height:4px;border-radius:50%;background-color:#b1b1ba;background-color:var(--icon-grey, #b1b1ba)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comments-cls1___72366c8481fe9aa1e5c",
	"cls2": "Comments-cls2___1f96f71214943147928 Comments-cls1___72366c8481fe9aa1e5c"
};
export default ___CSS_LOADER_EXPORT___;
